export default __webpack_public_path__ + "static/media/ForkKnifeOrange.0e326f0f.svg";